 
import { combineReducers } from "redux";
import automation from "./automation";
import bus from "./bus";
import configs from "./configs";
import fax from "./fax";
import institutions from "./institutions";
import returnOps from "./returnOps";
import returns from "./returns";
import status from "./status";
import prompts from "./prompts";
import ui from "./ui";

export interface Payload<T = any> {
    onSuccess?: (data: any) => void;
    onError?: (data: any) => void;
    onProgress?: (progress: number) => void;
    headers?: T;
    input?: T;
    data?: T;
    overrideAuth?: string;
    noLoad?: boolean;
}

const rootReducer = combineReducers({
    automation,
    bus,
    configs,
    fax,
    institutions,
    prompts,
    returnOps,
    returns,
    status,
    ui,
});

export default rootReducer;
